import React from 'react'
import HotkeysGroup from './HotkeysGroup'

export default function Actions() {
  return (
    <HotkeysGroup
      title="Actions (current or selected)"
      hotkeys={{
        'shift+c': 'Close',
        'shift+o': 'Open',
        '+': 'Star',
        '-': 'Unstar',
        '!': 'Mark as spam',
        g: 'Assign to me',
        a: 'Assign',
        s: 'Snooze',
        t: 'Tag',
        '.': 'Open more actions',
        m: 'Merge',
        v: 'Move',
      }}
    />
  )
}
